import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { isEmail, isNotEmpty } from "./util/validation";
import { useDispatch } from "react-redux";
import { ON_LOGIN } from "../redux/actions";

export default function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [enterValue, setEnterValue] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [loginError, setLoginError] = useState("");
  //hàm dữ liệu
  function handleValueChange(id, value) {
    setEnterValue((pre) => ({
      ...pre,
      [id]: value,
    }));
  }
  //hàm validate
  function validateForm() {
    const newErrors = {};

    if (!isEmail(enterValue.email) || !isNotEmpty(enterValue.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!isNotEmpty(enterValue.password)) {
      newErrors.password = "Please enter your password.";
    }

    return newErrors;
  }

  function handleSubmit(e) {
    e.preventDefault();
    console.log(enterValue);
    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const existingUsers = JSON.parse(localStorage.getItem("userArr")) || [];
      const user = existingUsers.find(
        (loginUer) =>
          loginUer.email === enterValue.email &&
          loginUer.password === enterValue.password
      );

      if (user) {
        //đăng nhập thành công
        dispatch({ type: ON_LOGIN, payload: user });
        localStorage.setItem("currentUser", JSON.stringify(user));
        //const existingUsers = JSON.parse(localStorage.getItem("currentUser"));

        //alert("Login successful.");

        navigate("/");
      } else {
        //đăng nhập thất bại
        setLoginError("email or password is not correct.");
        setEnterValue((prev) => ({ ...prev, password: "" }));
      }
    }
  }

  return (
    <div className=" container">
      <div className="sign-up text-muted fst-italic">
        <div className="text-center form-container">
          <h2 className="mb-4 h2-signup">Sign In</h2>
          <form className="form-signup" onSubmit={handleSubmit}>
            <div>
              <input
                className="input-signup"
                type="text"
                placeholder="Email"
                id="email"
                value={enterValue.email}
                onChange={(e) => handleValueChange("email", e.target.value)}
              />
              {errors.email && <div className="error-text">{errors.email}</div>}
            </div>
            <div>
              <input
                className="input-signup"
                type="text"
                placeholder="Password"
                id="password"
                value={enterValue.password}
                onChange={(e) => handleValueChange("password", e.target.value)}
              />
              {errors.password && (
                <div className="error-text">{errors.password}</div>
              )}
            </div>
            {loginError && <div className="error-text">{loginError}</div>}
            <div>
              <button className="btn-signup" type="submit">
                SIGN IN
              </button>
            </div>
            <div className="text-center p-t-45 p-b-4">
              <span>Create an account?</span>

              <Link to="/signup" className="link-signup">
                Sign up
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
